module.exports = __webpack_public_path__ + "static/media/1014785.6f1e894d.jpg";